import React from "react";
import { ChevronLeft } from "lucide-react";
import { TopicTile } from "./TopicTile";
import { GoogleAdSlot } from "./GoogleAdSlot";

function SidebarBanner() {
  return (
    <div className="card overflow-hidden relative" data-testid="sidebar-banner">
      <GoogleAdSlot
        slot="1099468409"
        mobileMinHeight={50}
        desktopMinHeight={100}
        testId="adsense-sidebar-banner"
      />
    </div>
  );
}

export function ArgomentiSidebar({ topics, activeTopic, onSelectTopic, onBackHome }) {
  return (
    <div className="h-full flex flex-col bg-cream" data-testid="argomenti-sidebar">
      <div className="px-4 pt-4 pb-3 flex items-center justify-between">
        <h2 className="text-[18px] font-display font-semibold" data-testid="argomenti-title">Argomenti</h2>
        <button
          onClick={onBackHome}
          className="text-[10px] uppercase tracking-widest text-muted hover:text-primary inline-flex items-center gap-1"
          data-testid="back-home-btn"
        >
          <ChevronLeft size={12} /> Home
        </button>
      </div>
      <div className="px-3 pb-2">
        <SidebarBanner />
      </div>
      <div className="flex-1 overflow-y-auto px-3 pb-4">
        <div className="grid grid-cols-2 gap-2">
          {topics.map((t) => (
            <TopicTile
              key={t.slug}
              topic={t}
              active={activeTopic === t.slug}
              onClick={onSelectTopic}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
